export interface ProductPersonalizationAdditionAddressRequirements {
  forPersons: 'FIRST_PERSON';
  countryRequired: boolean;
  zipCodeRequiredForCountries: null | string[];
}
